var component = require('../../../lib/js/component.js');
var AdobeLaunch = require('../../../lib/js/adobelaunch.js');

function InteractiveLmpCalculator() {
    this.initialize = function (element) {
        var _this = this;
        var $modal = $(element);
        var $select = $modal.find('.InteractiveLmpCalculator__programSelect');
        var $fallbackDisclaimer = $modal.find('.InteractiveLmpCalculator__fallbackDisclaimer');
        var $iframes = $modal.find('.InteractiveLmpCalculator__iframe');
        var defaultProgramValue = $select.find('option[selected]').val();
        var modalOpen = false;
        var calculatorLoaded = false;
        this.formViewedPushed = false;

        // On modal close: unload iframes and reset all state.
        // Clearing src stops any in-progress network requests and frees memory.
        $modal.on('hidden.bs.modal', function () {
            $iframes.each(function () {
                $(this).attr('src', 'about:blank');
            });
            $iframes.removeClass('is-active');
            $fallbackDisclaimer.removeClass('d-none');
            modalOpen = false;
            calculatorLoaded = false;

            // Reset dropdown to the server-rendered default
            var $defaultOption = $select.find('option[value="' + defaultProgramValue + '"]');
            if ($defaultOption.length) {
                $select.val(defaultProgramValue);
            } else {
                $select.find('option').first().prop('selected', true);
            }
            $select.trigger('change');
        });

        // On modal open: read src from each iframe's data-src attribute.
        // This defers the network request until the user actually opens the modal.
        $modal.on('shown.bs.modal', function () {
            $iframes.each(function () {
                $(this).attr('src', $(this).attr('data-src'));
            });
            $select.trigger('change');
            modalOpen = true;

            if (calculatorLoaded && !_this.formViewedPushed) {
                _this.pushFormViewedEvent();
            }
        });

        // Listen for the ready signal posted by LeadFusion calculators.
        window.addEventListener('message', function (event) {
            if (event.origin === 'https://expert.leadfusion.com' && event.data.message === 'CALCULATOR_READY') {
                var iframeWindows = $modal.find('iframe').toArray().map(function (iframe) {
                    return iframe.contentWindow;
                });

                if (iframeWindows.indexOf(event.source) !== -1) {
                    $fallbackDisclaimer.addClass('d-none');
                    calculatorLoaded = true;

                    if (modalOpen && !_this.formViewedPushed) {
                        _this.pushFormViewedEvent();
                    }
                }
            }
        }, false);

        if ($select.length) {
            var selectionCategory = $modal.data('selection-category') || '';

            // Remove options that aren't valid for this page's selection category
            $select.find('option').each(function () {
                var validFor = ($(this).data('valid-for') || '').split(',');
                if (validFor.indexOf(selectionCategory) === -1) {
                    $(this).remove();
                }
            });

            if ($select.find('option:selected').length === 0) {
                $select.find('option').first().prop('selected', true);
            }

            $select.on('change', function () {
                var programValue = $(this).find('option:selected').val();
                $iframes.removeClass('is-active');
                $modal.find('.InteractiveLmpCalculator__iframe[data-program="' + programValue + '"]').addClass('is-active');
            });

            $select.trigger('change');
        }

        if (element && element.parentNode !== document.body) {
            document.body.appendChild(element);
        }
    };

    this.pushFormViewedEvent = function () {
        AdobeLaunch.pushFormViewedEvent('LMP Calculator', 'Modal', 'LMP Calculator',
            this.$element.data('analytics-community-id'),
            this.$element.data('analytics-community-brand'),
            this.$element.data('analytics-zone'));
        this.formViewedPushed = true;
    };
}

module.exports = component(InteractiveLmpCalculator);